import { render, staticRenderFns } from "./sightsData.vue?vue&type=template&id=5335fac1&scoped=true&"
import script from "./sightsData.vue?vue&type=script&lang=js&"
export * from "./sightsData.vue?vue&type=script&lang=js&"
import style0 from "./sightsData.vue?vue&type=style&index=0&id=5335fac1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5335fac1",
  null
  
)

export default component.exports